<template>
  <div>
    <v-row class="ma-0 my-4 align-center justify-space-between">
      <h1 class="text-h5 font-weight-bold">Empresas</h1>
      <v-dialog
        v-model="showDialog"
        min-width="600"
        max-width="900"
        min-height="600"
        max-height="900"
        @keydown.esc="closeDialog"
        @click:outside="closeDialog"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="d-none d-md-block"
            rounded
            color="primary"
            depressed
            v-bind="attrs"
            v-on="on"
          >
            <span class="d-none d-md-block">Agregar Empresa</span>
          </v-btn>
          <v-btn
            class="d-block d-md-none"
            rounded
            color="primary"
            fab
            depressed
            x-small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </template>

        <template>
          <company-maintainer
            :company="selectedCompany"
            @update-list="getCompanies(this.page, this.limit)"
            @close-dialog="closeDialog"
          ></company-maintainer>
        </template>
      </v-dialog>


      <v-dialog
        v-model="deleteDialog"
        min-width="600"
        max-width="900"
        min-height="600"
        max-height="900"
        @keydown.esc="deleteDialog = false"
      >
        <template>
          <!--<confirmation-modal
              :user="selectedUser"
              @close-dialog="closeDeleteDialog"
              @delete-user="deleteUser"
            ></confirmation-modal>-->
        </template>
      </v-dialog>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="companies"
      :options.sync="options"
      :loading="loadingData"
      :items-per-page="limit"
      :server-items-length="totalItems"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 30, 40, 50]
      }"
    >
      <template v-slot:top>
        <v-row class="mx-0 mt-2 mb-1 align-center">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="stringToSearch"
              label="Buscar"
              placeholder="Nombre..."
              dense
              hide-details
              outlined
              append-icon="mdi-magnify"
              @click:append="searchString"
              @keyup="cleanSearch"
              @keyup.enter="searchString"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="7">
            <v-chip-group
              v-model="activeFilterIndex"
              mandatory
              active-class="primary--text font-weight-bold"
              @change="onActiveFilterChange"
            >
              <v-chip filter outlined>Activas</v-chip>
              <v-chip filter outlined>Inactivas</v-chip>
              <v-chip filter outlined>Todas</v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <span>{{ item.name }}</span>
      </template>
      <template v-slot:item.active="{ item }">
        <v-chip
          x-small
          :color="item.active ? 'green' : 'red'"
          dark
        >{{ item.active ? 'Activa' : 'Inactiva' }}</v-chip>
      </template>
      <template v-slot:item.actions="props">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              fab
              dark
              depressed
              x-small
              color="blue"
              v-bind="attrs"
              v-on="on"
              @click="openDialog(props.item)"
            >
              <v-icon small dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-2"
              fab
              dark
              depressed
              x-small
              color="green"
              v-bind="attrs"
              v-on="on"
              @click="viewCompanyDetails(props.item)"
            >
              <v-icon small dark>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Detalles</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <overlay :value="loadingOverlay"></overlay>
  </div>
</template>

<script>
//import UserMaintainer from '../components/UserMaintainer';
//import ConfirmationModal from '../components/ConfirmationModal';
import CompanyMaintainer from '../components/CompanyMaintainer.vue';
import CompanieServices from '../services/companie.service';
import Overlay from '../components/Overlay.vue';

export default {
  components: {
    CompanyMaintainer,
    //ConfirmationModal,
    Overlay
  },
  data() {
    return {
      loadingOverlay: false,
      stringToSearch: null,
      showDialog: false,
      deleteDialog: false,
      loadingData: true,
      options: {},
      companies: [],
      selectedCompany: null,
      activatedCompanie: null,
      limit: 10,
      page: 1,
      totalItems: 0,
      activeFilterIndex: 0,
      activeFilterMap: ['active', 'inactive', 'all'],
      headers: [
        {
          text: 'Nombre',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Estado',
          sortable: false,
          value: 'active'
        },
        {
          text: 'Acciones',
          sortable: false,
          value: 'actions'
        }
      ]
    };
  },
  mounted() {
    // this.getUsers(this.page, this.limit);
  },
  watch: {
    options: {
      handler() {
        this.page = this.options.page;
        this.limit = this.options.itemsPerPage;
        this.getCompanies(this.page, this.limit, this.stringToSearch);
      },
      deep: true
    }
  },
  methods: {
    async openDialog(companie) {
      this.showDialog = true;
      const res = await CompanieServices.getCompanyById(companie.id);
      this.selectedCompany = res.status === 'ok' ? res.data : companie;
    },
    closeDialog() {
      this.showDialog = false;
      this.selectedCompany = null;
      this.getCompanies(this.page, this.limit, this.stringToSearch);
    },
    triggerDeleteDialog(companie) {
      this.deleteDialog = true;
      this.selectedCompany = companie;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.selectedCompany = null;
    },
    async getCompanies(page, limit, search) {
      this.loadingData = true;
      const activeFilter = this.activeFilterMap[this.activeFilterIndex] || 'active';
      const res = await CompanieServices.getCompanies(page, limit, search, activeFilter);
      if (res.status === 'ok') {
        this.companies = res.data.companies;
        this.totalItems = res.data.totalItems;
      }
      this.loadingData = false;
    },
    onActiveFilterChange() {
      this.page = 1;
      // v-data-table pinta el pie de página ("X-Y de Z") a partir de
      // options.page, no de this.page — sin este reset queda con el valor
      // de la página en la que estabas antes de cambiar de filtro.
      this.options.page = 1;
      this.getCompanies(this.page, this.limit, this.stringToSearch);
    },
    async deleteCompanies() {
      const res = {};
      if (res.status === 'ok') {
        this.closeDeleteDialog();
        this.getCompanies(this.page, this.limit, '');
      }
    },
    showPolicy(url) {
      window.open(url);
    },
    formatDate(date) {
      try {
        date = new Date(date);
        let day = date.getDate();
        day = day >= 10 ? day : `0${day}`;
        let month = date.getMonth() + 1;
        month = month >= 10 ? month : `0${month}`;
        let year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (error) {
        return '';
      }
    },
    async searchString() {
      if (this.stringToSearch.length >= 3) {
        this.getCompanies(this.page, this.limit, this.stringToSearch);
      }
    },
    async cleanSearch() {
      if (!this.stringToSearch || this.stringToSearch.length == 0) {
        this.getCompanies(this.page, this.limit, this.stringToSearch);
      }
    },
    parseCompanyType(type) {
      switch (type) {
        case 'eb':
          return 'Employee Benefit';
        case 'b2c':
          return 'B2C';
        case 'b2b2c':
          return 'B2B2C';
        case 'assistance':
          return 'Asistencia Integrada';
        case 'dxp':
          return 'Dcto x planilla';
        case 'broker':
          return 'Broker';
        default:
          return '-';
      }
    },
    viewCompanyDetails(company) {
        if (company && company.id) {
            this.$router.push(`/business-relationships/companies/${company.id}`)
        }
    }
  }
};
</script>
